import { ProjectWelcomePage } from "@/features/projects/project-welcome.page";
import { createFileRoute } from "@tanstack/react-router";

// CR-181: temporary project home the creation flow lands on (no sidebar entry).
// Not in INCOGNITO_ALLOWED_PROJECT_SUBPATHS on purpose: the page mounts
// member-only reads, so incognito falls back to the project root.
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/welcome",
)({
  component: ProjectWelcomePage,
});
